import { getDeployEnv } from '../../analytics/env';

type LegitScriptSealProps = {
  className?: string;
};

export default function LegitScriptSeal({ className }: LegitScriptSealProps) {
  const deployEnv = getDeployEnv()?.toLowerCase();
  const isAllowedEnv = deployEnv === 'staging' || deployEnv === 'prod' || deployEnv === 'production';

  if (!isAllowedEnv) {
    return null;
  }

  return (
    <a
      href="https://www.legitscript.com/websites/?checker_keywords=jointalo.com"
      target="_blank"
      rel="noopener noreferrer"
      title="Verify LegitScript Approval for www.jointalo.com"
      className={className}
    >
      <img
        src="https://static.legitscript.com/seals/48224365.png"
        alt="Verify Approval for www.jointalo.com"
        width={73}
        height={79}
      />
    </a>
  );
}
